export default __webpack_public_path__ + "img/block-user-icon-b1a59f6efacd4e5e5c42083b0db4f4bc.png";